import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { AppConstants } from 'src/app/app.constants';
import { ProductService } from 'src/_lib/service/product.service';
import { CartService } from 'src/_lib/service/cart.service';
import { environment } from 'src/environments/environment.prod';
import { Router, RouterLink } from '@angular/router';
import { CommunicationService } from 'src/_lib/service/communication.service';
import { wishlistPostDataInterface } from 'src/_lib/interfaces/request-interfaces/wishlist-popup.interface';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgIf, NgFor } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { WishlistPopupComponent } from 'src/app/templates/featured-product/component/product-details/wishlist-popup/wishlist-popup.component';
import { CustomCurrencyPipe } from 'src/_lib/pipes/customCurrency.pipe';
import { GtmService } from 'src/_lib/service/gtm.service';
import { CartVerifyPopupComponent } from 'src/app/templates/cart/component/cart-verify-popup/cart-verify-popup.component';
import { BrowserService } from 'src/_lib/service/browser.service';

@Component({
  selector: 'app-application',
  templateUrl: './application.component.html',
  styleUrls: ['./application.component.scss'],
  standalone: true,
  imports: [NgIf, NgFor, ReactiveFormsModule, NgxIntlTelInputModule, FormsModule, RouterLink, CustomCurrencyPipe]
})
export class ApplicationComponent implements OnInit, OnChanges {
  firstObj: number = this.appConstants.firstObj;
  cdnImagePath = environment.cdnImagePath;
  commonImagePath: string = environment.commonImagePath;
  productVariations: any[] = [];
  order_key: number = null;
  promotionalPrice: number[] = [];
  promotion: number = null;
  inventryinfo: string;
  isMSRP: boolean = false;
  orderQuantity: { [variation_key: number | string]: number } = {};
  addToCartButtons: { [variation_key: number]: boolean } = {};
  inventoryFlag: boolean = true;
  openedImage: string = '';
  firstClicked: boolean;
  isMapPricingPromo: boolean = false;
  promotionType: string = null;
  totalItems: number = 0;
  limit: number = 10;
  offset: number = 0;
  currentPage: number = 1;
  totalPages: number = 0;
  totalPagesArray: number[] = [];
  totalVariationsCount: number = 0;
  vehicleForm: any | undefined = undefined;
  variationKeys: any[] = [];
  addToCartFlag: { [key: number]: boolean } = {};

  @Input() product_key: number;
  @Input() productName: string = '';
  @Input() selectedProductVariationKey: number = null;
  @Input() variationCount: number = 0;
  @Input() productPromotion: any;
  @Input() disableCheckoutButton: boolean = false;
  @Input() productFitToMMY: boolean = false;
  @Output() disdisableCheckoutButtonEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() sendSingleVariationDataEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() sendSamePriceEvent: EventEmitter<number> = new EventEmitter<number>();
  @ViewChild('appSection') appSection!: ElementRef;
  @Input() selectedColorKey: any | null = null;
  @Input() selectedSizeKey: any | null = null;

  constructor(
    private appConstants: AppConstants,
    private productHttp: ProductService,
    private cartService: CartService,
    private router: Router,
    private comm: CommunicationService,
    private dialogRefImagePopup: NgbModal,
    public dialog: MatDialog,
    private gtmService: GtmService,
    private browser: BrowserService
  ) { }

  ngOnInit(): void {
    this.comm.cartItemRemoved$.subscribe((flag) => {
      if (flag) {
        this.setInitialOrderQuantityandAddToCartQuantity();
        this.getOrderQuantityandAddToCartQuantityFromOrderItemsList();
      }
    });
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    const colorChanged =
      changes['selectedColorKey'] &&
      changes['selectedColorKey'].currentValue !== changes['selectedColorKey'].previousValue;
    const sizeChanged =
      changes['selectedSizeKey'] &&
      changes['selectedSizeKey'].currentValue !== changes['selectedSizeKey'].previousValue;
    const productChanged = !!changes['product_key'];
    const productFitToMMYChanged = changes['productFitToMMY'];
    const shouldReload = colorChanged || sizeChanged || productChanged || productFitToMMYChanged;
    if (shouldReload) {
      this.offset = 0;
      this.currentPage = 1;
      await this.loadVariations();
    }
    if (this.productVariations?.length === 1) {
      this.sendSingleVariationDataEvent.emit({
        promotionalPrice: +this.promotionalPrice?.[this.firstObj] || null,
        price: +this.productVariations[this.firstObj].customer_price,
        selectedProductVariationKey: +this.productVariations[this.firstObj].product_variation_key,
        selectedSku: this.productVariations[this.firstObj].sku,
        isSelectedSkuInventoryAvailable:
          this.productVariations[this.firstObj].inventory_qty_on_hand > 0
      });
    }
  }

  async loadVariations() {
    this.comm.vehicleFormSubject.subscribe(async (form) => {
      this.vehicleForm = form;
      if (!this.vehicleForm) {
        this.comm.fitmentNotify.next({
          success: true,
          cleared: true,
          message: 'Vehicle cleared, fitment reset',
        });
      }
      await this.fetchProductVariations();
      this.setInitialOrderQuantityandAddToCartQuantity();
      this.getOrderQuantityandAddToCartQuantityFromOrderItemsList();
      this.displayMSRPPrice();
    });
  }

  fetchProductVariations() {
    return new Promise<null>((resolve, reject) => {
      const payload = {
        offset: String(this.offset),
        limit: String(this.limit),
        size: this.selectedSizeKey || null,
        color: this.selectedColorKey || null,
        make: this.productFitToMMY ? this.vehicleForm?.select_make || '' : '',
        model: this.productFitToMMY ? this.vehicleForm?.select_model || '' : '',
        year: this.productFitToMMY ? this.vehicleForm?.select_year || '' : '',
        sub_model_1: this.productFitToMMY ? this.vehicleForm?.sub_model_1 || '' : '',
        sub_model_2: this.productFitToMMY ? this.vehicleForm?.sub_model_2 || '' : '',
        sub_model_3: this.productFitToMMY ? this.vehicleForm?.sub_model_3 || '' : ''
      };
      this.productHttp.productVariations(this.product_key, payload).subscribe({
        next: (response) => {
          if (response[this.firstObj]?.success === true) {
            const data = response[this.firstObj]?.data;
            const product_add_to_cart = data?.product_add_to_cart
            this.productVariations = data?.all_product_variations || [];
            this.inventoryFlag = data?.inventory_flag?.[this.firstObj]?.inventory === 0;
            this.totalVariationsCount = data?.all_product_variations_count || 0;
            this.productVariations.map((productData) => {
              if (product_add_to_cart == 'on') {
                if (productData?.add_to_cart == 'on') {
                  this.addToCartFlag[productData?.product_variation_key] = true;
                } else {
                  this.addToCartFlag[productData?.product_variation_key] = false;
                }
              } else {
                this.addToCartFlag[productData?.product_variation_key] = false;
              }
            });
            this.variationKeys = this.productVariations.filter(v => v?.product_variation_key).map(v => v.product_variation_key);
            if (this.variationKeys?.length > 0) {
              if (this.productFitToMMY) {
                this.checkFitment();
              } else {
                this.comm.fitmentNotify.next({
                  success: true,
                  cleared: true,
                  message: 'Fitment reset'
                });
              }
            }
            if (this.totalVariationsCount == 1 && this.variationCount > 1) {
              this.comm.slugNotify.next({
                sku: this.productVariations?.[this.firstObj]?.sku,
                product_variation_key: this.productVariations?.[this.firstObj]?.product_variation_key
              });
              this.productVariations = [];
              this.totalVariationsCount = 0;
            }
            this.setupPagination();
            this.calculatePromotion();
            resolve(null);
          } else {
            this.productVariations = [];
            resolve(null);
          }
        },
        error: (error: Error) => {
          console.error('Error fetching product variations', error);
          reject(null);
        }
      });
    });
  }

  checkFitment() {
    if (!this.vehicleForm || !this.variationKeys?.length) {
      this.comm.fitmentNotify.next({
        success: true,
        cleared: true,
        message: 'Fitment reset'
      });
      return;
    }
    const payload = {
      vehicle_make: String(this.vehicleForm.select_make),
      vehicle_model: String(this.vehicleForm.select_model),
      vehicle_year: String(this.vehicleForm.select_year),
      product_keys: this.product_key,
      product_variation_keys: this.variationKeys.join(',')
    };
    this.productHttp.checkFitmentData(payload).subscribe({
      next: (res) => this.comm.fitmentNotify.next(res),
      error: () => this.comm.fitmentNotify.next({
        success: false,
        message: 'Fitment check failed'
      })
    });
  }

  setInitialOrderQuantityandAddToCartQuantity() {
    this.orderQuantity = {};
    for (let prod of this.productVariations) {
      let variation_key = prod.product_variation_key;
      this.orderQuantity[variation_key] = 1;
      this.addToCartButtons[variation_key] = true;
    }
  }

  getOrderQuantityandAddToCartQuantityFromOrderItemsList() {
    const orderItemsList = this.cartService.getOrderItemsList();
    const variationKeys = Object.keys(this.orderQuantity);
    if (!!orderItemsList) {
      for (let key of variationKeys) {
        this.orderQuantity[key] = !!orderItemsList[key] ? orderItemsList[key] : 1;
        this.addToCartButtons[key] = !!orderItemsList[key] ? false : true;
      }
    }
  }

  async onAddToCart(product: any) {
    this.order_key = +this.browser.localStorage?.getItem('orderId') || null;
    const isNewProductFreight = product?.is_freight_shipping == 1;
    const cartShippingType = this.cartService.getCartShippingType();
    if (cartShippingType !== null) {
      const cartIsFreight = cartShippingType === 'freight';
      if (cartIsFreight !== isNewProductFreight) {
        this.dialog.open(CartVerifyPopupComponent, {
          data: {
            messages: [cartIsFreight ? 'Your cart contains freight shipping items. Only freight shipping products can be added.' : 'Your cart contains standard shipping items. Only standard shipping products can be added.'],
            isFreight: cartIsFreight
          }
        });
        return;
      }
    }
    this.disableCheckoutButton = true;
    this.disdisableCheckoutButtonEvent.emit(this.disableCheckoutButton);
    this.browser.localStorage?.setItem('ItemRecentlyAdded', 'true');
    await this.cartService.addToCart(product, this.order_key, this.orderQuantity[product.product_variation_key], product.calculated_price, product.promotion_key, false, '', false);
    const quantity = this.orderQuantity[product.product_variation_key] || 1;
    const price = Number(product.customer_price);
    this.gtmService.pushEvent('add_to_cart', {
      ecommerce: {
        currency: 'USD',
        value: price * quantity,
        items: [
          {
            item_id: product?.product_variation_key,
            item_name: this.productName,
            item_brand: product?.product_brand?.brand_name,
            item_category: product?.product_cat?.category?.name,
            item_variant: product?.sku,
            price: price,
            quantity: quantity
          }
        ]
      }
    });
    this.comm.itemCount.next(null);
    this.disableCheckoutButton = false;
    this.disdisableCheckoutButtonEvent.emit(this.disableCheckoutButton);
    this.addToCartButtons[product.product_variation_key] = false;
    this.cartService.setCartShippingType(isNewProductFreight);
  }

  fetchOrderItemKeysPromise(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.order_key = +this.browser.localStorage?.getItem('orderId') || null;
      if (!this.order_key) return resolve();
      this.cartService.cart(this.order_key).subscribe({
        next: (response) => {
          if (response[this.firstObj]?.success) {
            const orderItems =
              response[this.firstObj].data[this.firstObj].order_items || [];
            this.calculateTotalItems(orderItems);
            for (let prod of this.productVariations) {
              const match = orderItems.find(
                (item: any) =>
                  item.product_variation_key === prod.product_variation_key
              );
              if (match) prod.order_item_key = match.order_item_key;
            }
          }
          resolve();
        },
        error: (err) => {
          console.error('Error fetching cart data for order_item_key:', err);
          reject(err);
        },
      });
    });
  }

  async onQtyChange(event: any, prod: any): Promise<void> {
    this.order_key = +this.browser.localStorage?.getItem('orderId') || null;
    const qty = Number(event?.target?.value);
    if (isNaN(qty) || qty <= 0) return;
    try {
      await this.fetchOrderItemKeysPromise();
      const matchedProd = this.productVariations.find(
        (p) => p.product_variation_key === prod.product_variation_key
      );
      if (!matchedProd?.order_item_key) {
        console.warn('Order item key not found for product:', prod);
        return;
      }
      const qtyUpdate = {
        order_key: this.order_key,
        order_item_key: matchedProd.order_item_key,
        product_variation_key: matchedProd.product_variation_key,
        qty,
        price: matchedProd.customer_price,
        is_custom: matchedProd.product_variation_key === 0,
      };
      this.cartService.updateCart(qtyUpdate).subscribe({
        next: () => {
          matchedProd.line_price = qty * matchedProd.customer_price;
          this.cartService.setOrderItemsList(matchedProd.product_variation_key, qty);
          this.fetchOrderItemKeysPromise();
        },
        error: (err) => console.error('Error updating quantity:', err),
      });
    } catch (err) {
      console.error('Error executing onQtyChange sequence:', err);
    }
  }

  calculateTotalItems(orderItemsData: any) {
    if (orderItemsData?.length > 0) {
      this.totalItems = 0;
      orderItemsData.map((item: { qty: string }) => {
        this.totalItems = this.totalItems + Number(item.qty);
      });
    } else {
      this.totalItems = 0;
    }
    this.browser.localStorage?.setItem('ItemCount', String(this.totalItems));
    this.comm.itemCount.next(null);
  }

  calculatePromotion(): void {
    if(this.productPromotion !=null){
      this.isMapPricingPromo = this.productPromotion[this.firstObj]?.data?.[this.firstObj]?.is_map_pricing_promo == "1";
      if (!this.isMapPricingPromo) {
        this.promotion = +this.productPromotion[this.firstObj]?.data[this.firstObj]?.discount || 0;
        const variations = this.productVariations;
        this.promotionType = this.productPromotion[this.firstObj]?.data?.[this.firstObj]?.promotion_type;
        if (this.promotionType == "percentage_discount") {
          this.promotionalPrice = [];
          variations.forEach((product) => {
            this.promotionalPrice.push(+(Number(product?.customer_price) - (Number(product?.customer_price) * (this.promotion / 100))));
          });
        }
        else if (this.promotionType == "discount_flat_rate") {
          this.promotionalPrice = [];
          variations.forEach((product) => {
            this.promotionalPrice.push(+(Number(product.customer_price) - (this.promotion)));
          });
        }
      }
    } else {
      this.promotion = null;
      this.promotionType = null;
      this.promotionalPrice = null;
    }
    if (!!this.promotionalPrice && this.promotionalPrice[this.firstObj] && !!this.promotion && this.promotion > 0) {
      this.sendSamePriceEvent.emit(this.promotionalPrice[this.firstObj]);
    }
    else if (this.productVariations[this.firstObj]?.customer_price) {
      this.sendSamePriceEvent.emit(this.productVariations[this.firstObj]?.customer_price);
    }
  }

  displayMSRPPrice() {
    this.isMSRP = false;
    for (let product of this.productVariations) {
      if (Number(product.msrp_price) != 0) {
        this.isMSRP = true;
        break;
      }
    }
  }

  get displayStart(): number {
    return this.totalVariationsCount === 0 ? 0 : this.offset + 1;
  }

  get displayEnd(): number {
    return Math.min(this.offset + this.limit, this.totalVariationsCount);
  }

  setupPagination(): void {
    this.totalPages = Math.max(1, Math.ceil(this.totalVariationsCount / this.limit));
    if (this.currentPage > this.totalPages) this.currentPage = 1;
    this.offset = (this.currentPage - 1) * this.limit;
    this.totalPagesArray = this.getGroupedPages();
  }

  async changePage(page: number): Promise<void> {
    if (page < 1 || page > this.totalPages) return;
    this.currentPage = page;
    this.offset = (page - 1) * this.limit;
    this.totalPagesArray = this.getGroupedPages();
    await this.loadVariations();
    this.calculatePromotion();
    this.appSection?.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  onResize() {
    const width = this.browser.window?.innerWidth;
    if (width >= 992) return 15;
    if (width >= 768) return 12;
    return 9;
  }

  getGroupedPages(): number[] {
    const groupSize =this.onResize();
    const pages: number[] = [];
    const groupIndex = Math.floor((this.currentPage - 1) / groupSize);
    const startPage = groupIndex * groupSize + 1;
    const endPage = Math.min(startPage + groupSize - 1, this.totalPages);
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    if (endPage < this.totalPages) {
      pages.push(-1);
      pages.push(this.totalPages);
    }
    return pages;
  }

  openWishlistSuccess(): void {
    const dialogRef = this.dialog.open(WishlistPopupComponent, {
      width: '250px',
      data: { message: 'Product added to wishlist successfully.' },
    });
    dialogRef.afterClosed().subscribe(() => {
    });
  }

  async onAddToWishList(product: any) {
    const data: wishlistPostDataInterface = {
      qty: 1,
      calculated_price: product.customer_price,
      product_variation_key: product.product_variation_key,
      save_for_later: false
    }
    this.productHttp.wishlist(data).subscribe(
      {
        next: (response) => {
          if (response.status === 'Token is Invalid' || response.status === 'Token is Expired' || response.status == 'Authorization Token not found') {
            this.router.navigate(['/customer-login']);
          }
          else {
            const price = Number(product.customer_price) || 0;
            this.gtmService.pushEvent('add_to_wishlist', {
              ecommerce: {
                currency: 'USD',
                value: price,
                items: [
                  {
                    item_id: product?.product_variation_key,
                    item_name: this.productName,
                    item_brand: product?.product_brand?.brand_name,
                    item_category: product?.product_cat?.category?.name,
                    item_variant: product?.sku,
                    price: price,
                    quantity: 1
                  }
                ]
              }
            });
            this.openWishlistSuccess();
          }
        },
        error: (error: Error) => {
          this.router.navigate(['/customer-login']);
          console.error('Custom Error: Unexpected Error while fetching wishlist', error);
        }
      }
    );
  }

  openImageModal(content: TemplateRef<any>, image: string) {
    this.firstClicked = true;
    this.openedImage = !!image && image?.length > 0 ? image : `${this.commonImagePath}image_not_found.webp`
    this.dialogRefImagePopup.open(content, {
      backdrop: true,
      backdropClass: 'ngb-image-custom-backdrop',
      fullscreen: true,
      modalDialogClass: 'ngb-image-custom-modal',
      size: 'xl',
      windowClass: 'ngb-image-custom-window',
      animation: false
    });
  }

  onClickImageModalCancel(value?: boolean) {
    if (this.firstClicked == true) {
      this.firstClicked = false;
      return;
    }
    else {
      this.dialogRefImagePopup.dismissAll();
    }
  }
}